export default __webpack_public_path__ + "static/media/TicTac-Learn-Website-29-1.a3b204d6.png";